<script>
/* eslint-disable */
export default {
  props: ["item", "groupId", "position", "onSave"],
  data() {
    return {
      id: this.groupId,
      name: this.item.instruction ? this.item.instruction : "",
      timeout: null,
      itemId: this.item ? this.item.id : null,
      itemStatus: this.item ? this.item.status : null,
      uuid: this.item ? this.item.id : null,
    };
  },
  methods: {
    saveInstruction() {
      var data = {
        id: this.itemId,
        method_group: this.id,
        position: this.item.position,
        instruction: this.name,
      };
      this.saving = true;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.createUpdate(data);
      }, 1000);
    },
    createUpdate(instruction) {
      if (this.itemStatus == "create") {
        this.$store
          .dispatch("recipes/createMethodGroupInstruction", instruction)
          .then((id) => {
            this.itemId = id;
            this.itemStatus = "added";
            this.$emit("instruction-saved", {
              itemId: id,
              uuid: this.uuid,
              instruction: this.name,
              groupId: this.groupId,
            });
            this.$store.commit(`commons/setSavingForm`, "Saved");
          });
      } else {
        this.$store
          .dispatch("recipes/updateMethodGroupInstruction", instruction)
          .then((res) => {
            this.$store.commit(`commons/setSavingForm`, "Saved");
          });
      }
    },

    deleteMethodGroupItem() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("recipes/deleteMethodGroupInstruction", this.itemId)
        .then((res) => {
          this.$store.commit(`commons/setSavingForm`, "Deleted");
          this.$store.commit("commons/setPreloader", false);
        });
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
  },
};
</script>
<style scoped>
.instruction {
  display: grid;
  grid-template-columns: 0.5fr 8fr 0.5fr;
  gap: 15px;
  margin-bottom: 0.5rem;
  counter-increment: my-awesome-counter;
  position: relative;
}
.instruction:before {
  font-size: 14px;
  content: counter(my-awesome-counter);
  position: absolute;
  top: 7px;
  left: 20px;
  margin: auto;
}
.box-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.box-start {
  display: flex;
  align-items: center;
}
</style>
<template>
  <div class="instruction">
    <div class="box box-start">
      <b-icon icon="list"></b-icon>
    </div>
    <div class="box">
      <b-form-input
        size="sm"
        v-model="name"
        @keyup="saveInstruction"
        :id="`instruction_item_` + itemId"
      ></b-form-input>
    </div>
    <div class="box box-end">
      <b-icon
        icon="trash"
        class="cursor-pointer"
        variant="danger"
        @click="deleteMethodGroupItem(itemId)"
      ></b-icon>
    </div>
  </div>
</template>